import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiHintModule, TuiTextfieldControllerModule } from "@taiga-ui/core";
import { TuiInputModule } from "@taiga-ui/kit";
import { KwikUIInputCurrencyComponent } from "./input-currency.component";
import { NumericCurrencyTypeDirective } from "./input-currency.directive";

@NgModule({
  declarations: [KwikUIInputCurrencyComponent, NumericCurrencyTypeDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputModule,
    TuiTextfieldControllerModule
  ],
  exports: [KwikUIInputCurrencyComponent]
})
export class KwikUIInputCurrencyModule {}
